// extracted by mini-css-extract-plugin
module.exports = {"colFlex":"aboutyou_colFlex__1rqJY","aboutYouContainer":"aboutyou_aboutYouContainer__1kEXJ","sidebar":"aboutyou_sidebar__12Z69","sideMenu":"aboutyou_sideMenu__2bw1q"};